export default __webpack_public_path__ + "static/media/07.ca75548c.svg";